module.exports = __webpack_public_path__ + "img/regiter-icon08-selected.635e5835.png";